export class ExecutorSearch {
    public bin:number;
	public idBanco:number;
	public idTipoBin:number;
	public idAccion:number;
	public idEstadoBin:number;
	public fechaInicio:string;
	public fechaFin:string;
	public paginaActual:number;
	public origen:string;
	public idProcesador:number;
	public idGrupo:number;
    public tipoBin:string;
	constructor(){
		this.bin = null;
		this.idBanco = null;
		this.idTipoBin = null;
		this.idAccion = null;
		this.idEstadoBin=null;
		this.fechaInicio = null;
		this.fechaFin = null;
		this.paginaActual = 1;
		this.origen = null;
		this.idProcesador = null;
		this.idGrupo = null;
        this.tipoBin = "0";
	}
}
